var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApHoseReelsHydrantsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,23a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,30.4,23Zm0,3.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,30.4,26.6Z",
    transform: "translate(-17.277 -10.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.247,17.6V16.4A1.4,1.4,0,0,0,39.7,15.2H38.159a2.107,2.107,0,0,0-2.316-1.8h-.772v-3h2.316a.7.7,0,0,0,.772-.6V8.6a2.107,2.107,0,0,0-2.316-1.8h-.849a3.76,3.76,0,0,0-3.783-2.4h-.772V3.2A1.4,1.4,0,0,0,28.9,2H27.351a1.4,1.4,0,0,0-1.544,1.2V4.4h-.772a3.76,3.76,0,0,0-3.783,2.4H20.4a2.107,2.107,0,0,0-2.316,1.8V9.8a.7.7,0,0,0,.772.6h2.316v3H20.4a2.107,2.107,0,0,0-2.316,1.8H16.544A1.4,1.4,0,0,0,15,16.4v1.2a1.4,1.4,0,0,0,1.544,1.2h1.544A2.107,2.107,0,0,0,20.4,20.6h.772V34.4H20.4c-2.131,0-3.857,1.344-3.86,3a.7.7,0,0,0,.772.6H38.931a.7.7,0,0,0,.772-.6c0-1.656-1.729-3-3.86-3h-.772V20.6h.772a2.107,2.107,0,0,0,2.316-1.8H39.7A1.4,1.4,0,0,0,41.247,17.6ZM30.439,8V9.2H25.808V8Zm3.088,0V9.2H31.983V8ZM24.264,9.2H22.72V8h1.544Zm9.264,1.2v3.213a7.823,7.823,0,0,0-5.4-2.013,7.823,7.823,0,0,0-5.4,2.013V10.4Zm0,6.6c0,2.32-2.419,4.2-5.4,4.2s-5.4-1.88-5.4-4.2,2.419-4.2,5.4-4.2S33.523,14.682,33.527,17ZM22.72,20.387a7.823,7.823,0,0,0,5.4,2.013,7.823,7.823,0,0,0,5.4-2.013V24.8H22.72Zm0,5.613H33.527v1.2H22.72Zm13.9-17.4v.6H35.071V8h.772A.7.7,0,0,1,36.615,8.6ZM27.351,3.2H28.9V4.4H27.351ZM25.036,5.6h6.176A2.362,2.362,0,0,1,33.4,6.8H22.852A2.362,2.362,0,0,1,25.036,5.6Zm-5.4,3A.7.7,0,0,1,20.4,8h.772V9.2H19.632Zm-3.088,9V16.4h1.544v1.2Zm3.86,1.8a.7.7,0,0,1-.772-.6V15.2a.7.7,0,0,1,.772-.6h.772v4.8ZM38.027,36.8H18.22A2.362,2.362,0,0,1,20.4,35.6H35.843a2.362,2.362,0,0,1,2.184,1.2ZM28.9,34.4H27.351V32.6a.8.8,0,0,1,1.544,0Zm1.544,0V32.6a2.107,2.107,0,0,0-2.316-1.8,2.107,2.107,0,0,0-2.316,1.8v1.8H22.72v-6H33.527v6Zm6.176-15.6a.7.7,0,0,1-.772.6h-.772V14.6h.772a.7.7,0,0,1,.772.6ZM39.7,17.6H38.159V16.4H39.7Z",
    transform: "translate(-15 -2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApHoseReelsHydrantsIcon);
export default __webpack_public_path__ + "static/media/ap-hose-reels-hydrants-icon.e66860ccb04d3960370e01a26f0ccd4b.svg";
export { ForwardRef as ReactComponent };